/*
Controller: Payments

Operations:
  createPaymentSetup
  updatePaymentSetup
  getPayments
  getPaymentSetupDetails
*/
var Api = require('../config')
var PaymentRequestDef = require('../definitions/PaymentRequest')

var Payments = (function () {
  /*
  Operation: createPaymentSetup
  Setup Payment Method
  Parameters:
    bodyRequest: Payment object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Payment Method Setup failed
    HTTP 403: Operation not permitted
  */
  function createPaymentSetupPayments (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        PaymentRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/payments/setup'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updatePaymentSetup
  Setup Payment Method
  Parameters:
    paymentId: Id of payment
    bodyRequest: Payment object
  Responses:
    HTTP 200: Valid response
    HTTP 400: Payment Method Setup failed
    HTTP 403: Operation not permitted
  */
  function updatePaymentSetupPayments (paymentId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!paymentId) {
          throw new Error('paymentId: Missing parameter')
        }
        if (paymentId && !(typeof paymentId === 'string')) {
          throw new Error('paymentId: Wrong type: Got "' + (typeof paymentId) + '", but expected: "string"')
        }
        PaymentRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/payments/setup/{paymentId}'
      path = path.replace('{' + 'paymentId' + '}', paymentId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getPayments
  Query existing payments
  Parameters:
    userId: Id of the user
    sortBy: field to sort by, possible values: &#39;paymentDate, venderId, legalName&#39;
    sortDirection: direction to sort by, asc or desc
    filter: filter by status, possible values: &#39;completed &amp; upcoming&#39;
    search: possible values: &#39;vendorId, legalName, amount&#39;
    page: page number, starting with 1
    perPage: number of items per page, max 50
  Responses:
    HTTP 200: List of payments
    HTTP 424: The requested resource depends on another resource that has failed.
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getPaymentsPayments (userId, sortBy, sortDirection, filter, search, page, perPage) {
    return new Promise(function (resolve, reject) {
      try {
        if (!userId) {
          throw new Error('userId: Missing parameter')
        }
        if (userId && !(typeof userId === 'string')) {
          throw new Error('userId: Wrong type: Got "' + (typeof userId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['sortBy'] = sortBy
      parameters['sortDirection'] = sortDirection
      parameters['filter'] = filter
      parameters['search'] = search
      parameters['page'] = page
      parameters['perPage'] = perPage
      var path = '/payments/{userId}'
      path = path.replace('{' + 'userId' + '}', userId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getPaymentSetupDetails
  Get Payment Setup Details
  Parameters:
    userId: Id of the user
    vendorId: vendorId of the user
  Responses:
    HTTP 200: Get Vendor data including banking details
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getPaymentSetupDetailsPayments (userId, vendorId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!userId) {
          throw new Error('userId: Missing parameter')
        }
        if (userId && !(typeof userId === 'string')) {
          throw new Error('userId: Wrong type: Got "' + (typeof userId) + '", but expected: "string"')
        }
        if (!vendorId) {
          throw new Error('vendorId: Missing parameter')
        }
        if (vendorId && !(typeof vendorId === 'string')) {
          throw new Error('vendorId: Wrong type: Got "' + (typeof vendorId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/payments/{userId}/{vendorId}'
      path = path.replace('{' + 'userId' + '}', userId)
      path = path.replace('{' + 'vendorId' + '}', vendorId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['createPaymentSetup'] = createPaymentSetupPayments
  ret['updatePaymentSetup'] = updatePaymentSetupPayments
  ret['getPayments'] = getPaymentsPayments
  ret['getPaymentSetupDetails'] = getPaymentSetupDetailsPayments
  return ret
})()

module.exports = Payments
